import $ from "jquery";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const HoverButton = ({ title, children, to, btnclassname }) => {
  useEffect(() => {
    $(document)
      .on("mouseenter", ".btn", function (e) {
        const parentOffset = $(this).offset();
        const relX = e.pageX - parentOffset.left;
        const relY = e.pageY - parentOffset.top;
        $(this).find("span").css({ top: relY, left: relX });
      })
      .on("mouseout", ".btn", function (e) {
        const parentOffset = $(this).offset();
        const relX = e.pageX - parentOffset.left;
        const relY = e.pageY - parentOffset.top;
        $(this).find("span").css({ top: relY, left: relX });
      });

    return () => {
      $(document).off("mouseenter mouseout", ".btn");
    };
  }, []);
  
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Link
      to={to}
      className={btnclassname}
      onClick={handleScrollToTop}  
    >
      <label>
        {children || title}
      </label>
      <span></span>
    </Link>
  );
};

export default HoverButton;
